/**
 * Wagamour Global Design System
 * Single source of truth for colors, spacing, radius, shadows.
 * Use everywhere — no inline colors or one-off values.
 */

export const colors = {
  background: '#FAFAFB',
  surface: '#FFFFFF',
  border: '#F0F0F2',

  textPrimary: '#1C1C1E',
  textSecondary: '#6B6B73',

  brandPrimary: '#E86C8D',
  brandGradient: 'linear-gradient(135deg, #E86C8D 0%, #C45CFF 100%)',

  success: '#34C759',
  warning: '#FF9F0A',
  info: '#3B82F6',

  aiAccent: '#7C5CFF',
}

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
}

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
}

export const shadows = {
  card: '0 2px 8px rgba(0,0,0,0.04)',
  hover: '0 4px 16px rgba(0,0,0,0.08)',
}
